export interface Command {
    id: string;
    label?: string;
    icon?: string;
}

export interface CommandHandler {
    /**
     * Execute this handler.
     *
     * Don't call it directly, use `CommandService.executeCommand` instead.
     */
    execute(...args: any[]): any;
    /**
     * Test whether this handler is enabled (active).
     */
    isEnabled?(...args: any[]): boolean;
    /**
     * Test whether menu items for this handler should be visible.
     */
    isVisible?(...args: any[]): boolean;
    /**
     * Test whether menu items for this handler should be toggled.
     */
    isToggled?(...args: any[]): boolean;
}

export const CommandService = Symbol.for('CommandService');

export interface CommandService {
    executeCommand<T>(command: string, ...args: any[]): Promise<T | undefined>;
    getAllCommands(): Readonly<Command & { handlers: CommandHandler[] }>[];
}
